// app.quotes.new.tsx — the new-quote builder screen (server-side action
// validation errors + the client-side form UI).
export const quoteNew = {
  errors: {
    trialEndedWithDate: "Your trial ended on {{date}} — choose a plan to create quotes.",
    trialEndedNoDate: "Your trial ended — choose a plan to create quotes.",
    quotaExceeded:
      "You've used all {{cap}} free quotes in the last 30 days. Upgrade to Starter for unlimited quotes.",
    pickCompany: "Pick a company first.",
    companyGidInvalid: "Company ID must be a Shopify GID (gid://shopify/Company/...).",
    buyerEmailRequired: "Buyer email is required.",
    buyerEmailInvalid: "Enter a valid buyer email address (e.g. buyer@company.com).",
    lineRequired: "At least one line is required.",
    invalidExpiry: "Invalid expiry date.",
    linesPayloadInvalid: "Lines payload invalid.",
    addAtLeastOneLine: "Add at least one line.",
    tooManyLines: "Quote exceeds 500 lines — split into smaller quotes.",
    invalidQuantity: "Invalid quantity for {{title}}.",
    invalidQuotePrice: "Invalid quote price for {{title}}.",
    invalidOriginalPrice: "Invalid original price for {{title}}.",
    createFailed: "Couldn't create the quote. Please try again or contact support if this persists.",
  },
  heading: "New quote",
  trialBanner: {
    withDate:
      "Your trial ended on {{date}}. Choose a plan to create and send quotes — your existing quotes stay viewable.",
    noDate: "Your trial ended. Choose a plan to create and send quotes — your existing quotes stay viewable.",
    choosePlan: "Choose a plan",
  },
  upgradeLink: "Upgrade to Starter",
  noCompaniesBanner: {
    prefix:
      "No B2B companies found on this store yet. Quote Desk needs at least one B2B Company to assign a quote to —",
    createLink: "create one here in about 20 seconds",
    middle: "(we set up the contact and location for you), or",
    manualLink: "set it up manually in Shopify admin",
  },
  companiesErrorBanner:
    "We couldn't list your B2B companies. B2B may not be enabled on this shop, or the app's scopes haven't been granted yet. You can still paste a Company GID manually below.",
  buyerSection: {
    heading: "Buyer",
    companyLabel: "Company",
    priceListHint:
      "This company has an assigned price list — line prices below are prefilled from it. You can still override any line.",
    currencyMismatch:
      "Price list ‘{{name}}’ is in {{listCurrency}} but this store quotes in {{shopCurrency}} — prices were not auto-applied. To use these prices, edit the price list to match the store currency, or set a separate {{shopCurrency}} price list for this company.",
    companyGidLabel: "Company GID",
    companyGidHelp: "Paste the Company GID from Shopify admin → Customers → Companies (the URL contains it).",
    companyNameLabel: "Company name",
    buyerEmailLabel: "Buyer email",
    buyerNameLabel: "Buyer name",
    expiresAtLabel: "Expires at (optional)",
  },
  lineItemsSection: {
    heading: "Line items",
    emptyBanner: 'No line items yet. Click "Pick products" to choose from your catalog.',
    skuLabel: "SKU {{sku}}",
    qtyLabel: "Qty",
    originalPriceLabel: "Original price",
    quotePriceLabel: "Quote price",
    fromPriceListBadge: "From price list",
    lineTotal: "Line: {{amount}}",
    pickProducts: "Pick products",
    addMoreProducts: "Add more products",
    subtotal: "Subtotal: {{amount}}",
    remove: "Remove",
    resourcePickerUnavailable: "Resource picker is unavailable. Open this app from inside Shopify admin.",
  },
  notesSection: {
    heading: "Notes",
    internalNoteLabel: "Internal note (not visible to buyer)",
    buyerNoteLabel: "Note to buyer (visible on the quote page)",
  },
  submit: {
    creating: "Creating…",
    create: "Create quote",
  },
};
